import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';

export const DropdownItem = styled(RouterLink)<{
  $isSelected: boolean;
}>`
  display: grid;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
  cursor: pointer;
  width: 240px;
  transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1);

  ${({ $isSelected, theme }) =>
    $isSelected &&
    ` &&& {
      background: ${theme.color.brand01RGBA(0.1)};
    }
  `}

  &:hover {
    background: ${({ theme }) => theme.color.paper};
  }
`;
